module.exports = __webpack_public_path__ + "img/conference_outline.ad8c9fa0.svg";